import { SimpleModal } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStore } from 'src/stores';
import SkipBillContent from './content';
const SkipBillModal = observer(() => {
  const store = useStore();
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const skipModal = currentCompany.billingTab.skipModal || {};
  const handleClose = () => {
    currentCompany === null || currentCompany === void 0 || currentCompany.billingTab.setSkipModalOpen(false);
    currentCompany === null || currentCompany === void 0 || currentCompany.billingTab.clearSkipModal();
  };
  const getTitleBeginning = () => {
    if (skipModal.isFromHistory) return '';else if (skipModal.isEdit) return 'Edit';else return 'Skip';
  };
  const defaultTitle = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getTitleBeginning(), " ", skipModal.utilityName, " ", skipModal.cycleName, skipModal.isFromHistory ? '' : '?'), /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    variant: "h6"
  }, skipModal.buildingAddress));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    isOpen: currentCompany.billingTab.isSkipModalOpen,
    noFooter: true,
    noPadding: true,
    title: defaultTitle,
    variant: "middle"
  }, /*#__PURE__*/React.createElement(SkipBillContent, {
    handleClose: handleClose
  }));
});
export default SkipBillModal;